export enum StorageKey
{
  TOKEN = 'Token',
}
